import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox, Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { isFormError, validatePasswordFormat } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { ConfirmDailog } from 'Components/modal'
import { clearEventAction } from 'Store/manage-user/actions'
import { FormItem } from 'Components/form'
import InputPassword from 'Components/form/InputPassword'
import { passwordFormatConfig } from 'helpers/constanst'
import { resetUserPasswordAPI } from 'Store/manage-user/api'
import { ResetPasswordReq } from 'Store/manage-user/types'
import { selectActionEvent } from 'Store/manage-user/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const ResetPin: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, event, onSuccess = () => {}, id = 0 } = props
  const [formError, setFormError] = useState([] as string[])
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const [passwordValidKey, setPasswordValidKey] = useState<string[]>([])
  const dispatch = useDispatch()

  useEffect(() => {
    const validKey = validatePasswordFormat(password)
    setPasswordValidKey(validKey)
  }, [password])

  const validateForm = () => {
    const error = []

    if (passwordValidKey.length < 5) {
      error.push('password')
    }

    if (confirmPassword !== password) {
      error.push('confirmPassword')
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const onUpdate = (): void => {
    if (!validateForm()) return
    setConfirmDialog(false)
    const req: ResetPasswordReq = {
      password: password,
      id,
    }
    dispatch(resetUserPasswordAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormError([])
      setPasswordValidKey([])
      setPassword('')
      setConfirmPassword('')
    }
  }, [visible])

  const onClickReset = () => {
    if (!validateForm()) return
    setConfirmDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const title = 'รีเซ็ตรหัสผ่านใหม่สำหรับผู้ใช้งาน'
  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton text="ยืนยันการรีเซ็ตรหัสผ่าน" onClick={onClickReset} />
    </Space>
  )

  const ConfirmResetDailog = (
    <ConfirmDailog
      title="ยืนยันรีเซ็ตรหัสผ่าน"
      description={`คุณแน่ใจที่จะเปลี่ยนรหัสผ่านของผู้ใช้นี้หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onUpdate}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const onUpdatePassword = (val: string): void => {
    setPassword(val)
    if (formError.length > 0) {
      validateForm()
    }
  }

  const onUpdateConfirmPassword = (val: string): void => {
    setConfirmPassword(val)
    if (formError.length > 0) {
      validateForm()
    }
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'50%'}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col lg={24} xs={24}>
          <BoxTitle>รหัสผ่าน</BoxTitle>
          <FormItem label="" status={isError('password')} error="รูปแบบของรหัสผ่านไม่ถูกต้อง">
            <InputPassword
              type="password"
              value={password}
              placeholder="รหัสผ่าน"
              onChange={onUpdatePassword}
            />
          </FormItem>
        </Col>
        <Col lg={24} xs={24}>
          <BoxTitle>ยืนยันรหัสผ่านอีกครั้ง</BoxTitle>
          <FormItem label="" status={isError('confirmPassword')} error="รหัสผ่านไม่ตรงกัน">
            <InputPassword
              type="password"
              value={confirmPassword}
              placeholder="ยืนยันรหัสผ่าน"
              onChange={onUpdateConfirmPassword}
            />
          </FormItem>
        </Col>
        <Col lg={24} xs={24}>
          <Description>
            <Space direction="vertical" size={'small'}>
              รหัสผ่านประกอบไปด้วย
              {passwordFormatConfig.map((item, index) => {
                return (
                  <CircleCheckBox checked={passwordValidKey.includes(item.value) ? true : false} key={index}>
                    {item.name}
                  </CircleCheckBox>
                )
              })}
            </Space>
          </Description>
        </Col>
      </Row>
      {ConfirmResetDailog}
    </DetailDrawer>
  )
}

const CircleCheckBox = styled(Checkbox)`
  cursor: default;
  input {
    cursor: default;
  }
  span,
  label {
    border-radius: 10px;
  }
`
const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const Description = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
  span {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ResetPin)
